import React from 'react';
import { GridReactContextProvider } from '../../../Utils/DataGridWrapper/GridContext';
import LoadingSpinner from '../../LoadingSpinner/LoadingSpinner';
import { useUserAdminOrgs } from '../../Hooks/UseUserAdminOrgs';
import { CertificationDashboardTable } from './CertificationDashboardTable/CertificationDashboardTable';
import './CertificationDashboard.scss';

/**
 * CertificationDashboard Component
 *
 * Parent container component for the Certification Dashboard.
 * Displays user certification status tracking with urgency-based prioritization.
 *
 * @returns {JSX.Element} Rendered certification dashboard component
 */
export const CertificationDashboard = () => {
    const { adminOrganizationOptions, adminOrganizations, isOrgsLoading } = useUserAdminOrgs({
        withAllOption: true,
        withCoursesAndSignDocs: true
    });

    return (
        <div className="CertificationDashboard">
            <GridReactContextProvider>
                {adminOrganizationOptions && adminOrganizations && !isOrgsLoading ? (
                    <div className="CertificationDashboard__content">
                        <CertificationDashboardTable
                            organizationsOptions={adminOrganizationOptions}
                            adminOrganizations={adminOrganizations}
                            tableButtons={null}
                        />
                    </div>
                ) : (
                    <LoadingSpinner />
                )}
            </GridReactContextProvider>
        </div>
    );
};

export default CertificationDashboard;
